import { Button, Stack, Typography } from '@mui/material'
import { UseFormSetValue } from 'react-hook-form'
import { Fade, TextInputFieldProps } from 'utoniq-ui'

import { CreateItemProps } from '@/components/pages/ConsoleItemCreate/template/ItemCreateForm'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

import { TextInputCell } from './Commons'

type IssueInputCellProps = {
  setValue: UseFormSetValue<CreateItemProps>
  hasIssuedNumber: boolean
  inputProps: Omit<TextInputFieldProps, 't'>
  defaultNumber?: number
}
export const IssueInputCell: Cell<IssueInputCellProps> = ({
  hasIssuedNumber,
  setValue,
  inputProps,
  defaultNumber = 100,
}) => {
  const { t } = useTranslation('consoleItemCreate')
  const options = [
    { value: true, label: t('limited') },
    { value: false, label: t('noLimit') },
  ]
  return (
    <CellFrame sx={{ pb: 7 }}>
      <Typography variant="h5">{t('issuedNumberLabel')}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ pt: 2 }}>
        {t('issuedNumberDesc')}
      </Typography>
      <Stack direction="row" spacing={2} sx={{ py: 2 }}>
        {options.map((option, index) => (
          <Button
            key={index}
            variant={
              hasIssuedNumber === option.value ? 'contained' : 'outlined'
            }
            onClick={() => {
              setValue('hasIssuedNumber', option.value)
              if (!option.value) {
                setValue('issuedNumber', null, {
                  shouldValidate: true,
                  shouldDirty: true,
                })
              } else {
                setValue('issuedNumber', defaultNumber, {
                  shouldValidate: true,
                  shouldDirty: false,
                })
              }
            }}
          >
            {option.label}
          </Button>
        ))}
      </Stack>
      {hasIssuedNumber && (
        <Fade>
          <TextInputCell textFieldProps={{ sx: { mb: 0 } }} {...inputProps} />
        </Fade>
      )}
    </CellFrame>
  )
}
